module.exports = "./img/d71cb9386a895e4b3247c7ae65971a36.png";